import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  popoverPaper: {
    padding: theme.spacing(0),
    marginTop: theme.spacing(1.5),
    width: 140,
  },
  menuItem: {
    margin: theme.spacing(1),
    gap: theme.spacing(1),
    padding: theme.spacing(0.5, 1),
    borderRadius: 4,
  },
}));
